/**
 * 유지보수 — /maintenance (2026-07-19 메뉴 재구성으로 영업진행현황 탭에서 독립 승격).
 *
 * 내용은 기존 MaintenanceTab 그대로 (계약현황·월별 발행내역 서브탭 + 월별 발행일자 뷰 토글).
 * 권한: 전 직원 — v2.251.0 (2026-10-14) 부터 조회 전용(viewer)도 본다. **금액은 서버가 null 로 가린다**(화면 「***」 ·
 *   월별 발행합계는 금액 대신 ●) · 비고 속 금액도 「***」. 엑셀·예산 산정근거·계약 문서·쓰기는 viewer 에게 없다(서버 sales 이상).
 * v2.252.0: 기준 시각·부가세 안내·조회 전용 안내는 여기 머리줄에 — 탭 줄 오른쪽에 두면 1366 폭에서 탭이 접혔다(실측).
 */

import { MaintenanceTab } from '../components/MaintenanceTab';
import { LastUpdateBadge } from '../components/LastUpdateBadge';
import { VatNote } from '../components/VatNote';
import { useAuth } from '../lib/auth-context';

export function MaintenancePage() {
  const { user } = useAuth();
  const isViewer = user?.role === 'viewer';
  return (
    <div className="p-8">
      <h1 className="ui-page-title">유지보수</h1>
      <div className="ui-page-sub mb-3 flex items-center gap-3 flex-wrap">
        <span>유지보수 계약 · 계산서 발행 · 월별 발행합계</span>
        {isViewer ? (
          <span title="조회 전용 계정 — 계약·기간·담당·장비·현장 연락처·발행 여부는 보이고, 금액은 가려집니다">
            🔒 조회 전용 — 금액은 *** 로 가려집니다
          </span>
        ) : (
          <VatNote />
        )}
        <LastUpdateBadge />
      </div>
      <MaintenanceTab />
    </div>
  );
}
